import React from "react";
import { Button, Flex, Modal, Text } from "@jsq/ds/core";
import { Form, FormTextarea } from "@jsq/ds/forms";
import styles from "./styles.scss";

interface Props {
  isSubmitting: boolean;
  handleApprove: (comments?: string) => void;
  handleCloseModal: () => void;
}

interface FormValues {
  internalComments?: string;
}

export function ApproveModal({
  isSubmitting,
  handleApprove,
  handleCloseModal,
}: Props): React.ReactElement<Props> {
  const handleSubmit = (formValues: FormValues) => {
    handleApprove(formValues.internalComments);
  };

  return (
    <Modal show onHide={handleCloseModal} className={styles.ApproveModal__container}>
      <Modal.Header closeButton>
        <Modal.Title>Approve</Modal.Title>
      </Modal.Header>
      <Form initialValues={{ internalComments: "" }} onSubmit={handleSubmit}>
        <Modal.Body>
          <Flex flexDirection="column" gap={20}>
            <Text variant="regular-md">
              Approve the subscription package to allow the investor&apos;s position to be
              created.
            </Text>
            <Flex flexDirection="column" gap={4}>
              <FormTextarea
                name="internalComments"
                label="Internal comments (optional)"
                isFullWidth
                size="x-small"
                data-cy="approve-internal-comments-text"
              />
              <Text variant="secondary-sm">Will not be shared with prospect</Text>
            </Flex>
          </Flex>
        </Modal.Body>
        <Modal.Footer>
          <Flex justifyContent="flex-end">
            <Button
              variant="neutral"
              type="button"
              onClick={handleCloseModal}
              className="inline-sm"
            >
              Cancel
            </Button>
            <Button type="submit" isLoading={isSubmitting} data-cy="review-confirm-approval">
              Approve
            </Button>
          </Flex>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
